/* eslint-disable @altermaind/you-shall-not-pass */
// Auto-generated from OpenAPI enums. Do not edit manually.

export enum InvitationStatus {
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  EXPIRED = 'Expired',
  REVOKED = 'Revoked',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum DelegationRole {
  HR_DELEGATE = 'hr-delegate',
}

export enum UserContext {
  ADMIN = 'ADMIN',
  LEARNING = 'LEARNING',
}

export enum PlanType {
  STANDARD = 'STANDARD',
  CUSTOM = 'CUSTOM',
  CUSTOM_OFFLINE = 'CUSTOM_OFFLINE',
}

export enum PaymentMethod {
  CARD = 'CARD',
  SEPA_DEBIT = 'SEPA_DEBIT',
}

export enum IntervalType {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum MetricName {
  LEARNING_LICENSES = 'LEARNING_LICENSES',
  ADMIN_LICENSES = 'ADMIN_LICENSES',
}

export enum UserAuthErrorType {
  SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
  SUBSCRIPTION_BETA_EXPIRED = 'SUBSCRIPTION_BETA_EXPIRED',
  SUBSCRIPTION_PAYMENT_FAILED = 'SUBSCRIPTION_PAYMENT_FAILED',
  SUBSCRIPTION_MISSING = 'SUBSCRIPTION_MISSING',
}

export enum UserWarningType {
  SUBSCRIPTION_MISSING_PAYMENT_METHOD = 'SUBSCRIPTION_MISSING_PAYMENT_METHOD',
  SUBSCRIPTION_TRIAL_EXPIRING = 'SUBSCRIPTION_TRIAL_EXPIRING',
  SUBSCRIPTION_BETA_EXPIRING = 'SUBSCRIPTION_BETA_EXPIRING',
  SUBSCRIPTION_PAYMENT_FAILED = 'SUBSCRIPTION_PAYMENT_FAILED',
  SUBSCRIPTION_MISSING = 'SUBSCRIPTION_MISSING',
}
